
export const keys = {
    all: ["offline"],
    data: (customerID: number) => [
        ...keys.all,
        "data", {
            customerID
        }
    ],
    groups: (customerID: number) => [
        ...keys.all,
        "groups", {
            customerID
        }
    ],
    configuration: () => [
            ...keys.all,
            "configuration", {
            }
        ]
};
